<template>
	<div v-if="this.customer">
		<menu-desktop :menuSelected="this.menuSelected" :customer="this.customer" />

		<menu-mobile v-if="this.user" :user="this.user" :menuSelected="this.menuSelected" :customer="this.customer" />
		<div class="container-right">
			<div class="barTop" :class="menuSelected.beneficiaries ? 'view' : 'bar-top-white'">
				<div class="logo-mobile" v-if="menuSelected.newOrder">
					<img src="@/assets/images/logo.jpg" />
				</div>
				<div class="menu-white" v-if="menuSelected.beneficiaries" @click="openMenu(true)">
					<img src="@/assets/images/menu-burger-alb.svg" />
				</div>

				<div class="mobile-nav">
					<div class="arrow-back" @click="goBack()">
						<img src="@/assets/images/arrow-back.svg" />
					</div>
					<div class="page-title">
						<h3>{{ "Beneficiaries" }}</h3>
					</div>
					<div class="menu-white" @click="openMenu(true)">
						<img src="@/assets/images/menu-burger-gri.svg" />
					</div>
				</div>
				<TopBar v-if="this.user" :user="this.user" />
			</div>

			<div class="content">
				<Beneficiaries :customer="this.customer" :userRole="this.selectedCompany.role" :user="this.user" />
			</div>
		</div>
	</div>
</template>

<style scoped src="@/assets/styles/beneficiary.css"></style>

<script>

import MenuDesktop from "@/components/company/customer/MenuDesktop.vue";
import MenuMobile from "@/components/company/customer/MenuMobile.vue";
import TopBar from "@/components/company/TopBar.vue";
import Beneficiaries from "@/components/company/customer/Beneficiaries.vue";

export default {
	components: {
		MenuDesktop,
		MenuMobile,
		Beneficiaries,
		TopBar,
	},
	data() {
		return {
			user: null,
			customer: null,
			selectedCompany: null,
			menuSelected: {
				beneficiaries: true,
			},
		};
	},
	created() {
		this.showModalPopup("modal_popup_loading", true);

		this.user = this.getUserData();
		this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
		this.customer = this.getCustomerData('ben c', this.selectedCompany.role);
		if (this.user !== null) {
			this.showModalPopup("modal_popup_loading", false);

		}
	},
	computed: {
		dataLoaded() {
			return this.$store.state.customerDataLoaded;
		},
	},
	watch: {
		'$store.state.customerDataLoaded': {
			handler() {
				// update locally relevant data
				if (this.customer == null || this.user == null){
					this.user = this.getUserData();
					this.customer = this.getCustomerData('ben w', this.selectedCompany.role);
					this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
					this.showModalPopup("modal_popup_loading", false);
				}
			}
		}
	}
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
